import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { checkIsTempUser } from 'Modules/AAA/selectors';
import TempUserButton from 'Components/Header/TempUserButton';
import UserButton from 'Components/Header/UserButton';
import ProfileDropdown from 'Components/Header/ProfileDropdown/ProfileDropdown';
import styled from 'styled-components';

interface IProfileButton {
  withUserDropdownMenu?: boolean;
  className?: string;
}

const ButtonWrapper = styled.div`
  margin-left: auto;
`;

const ProfileButton: React.FC<IProfileButton> = ({ withUserDropdownMenu, className }) => {
  const isTempUser = useSelector(checkIsTempUser);

  const getButton = useMemo(() => {
    if (isTempUser) {
      return <TempUserButton />;
    } else if (withUserDropdownMenu) {
      return (
        <ProfileDropdown>
          <UserButton />
        </ProfileDropdown>
      );
    }
    return <UserButton />;
  }, [isTempUser, withUserDropdownMenu]);

  return <ButtonWrapper className={className}>{getButton}</ButtonWrapper>;
};

export default ProfileButton;
